<template lang="pug">
div
  .row.mb-3(v-if="hasAnyAlerts")
    .col-md-4.col-sm-6.mb-3(v-if="alerts.overdue_invoices > 0")
      .app-card.p-3.h-100
        .d-flex.justify-content-between.align-items-center
          div
            .tw-text-xs.tw-text-gray-500.tw-uppercase.tw-font-semibold.mb-1
              i.fa-solid.fa-exclamation-triangle.me-1.tw-text-red-500
              | {{$I18n.t('vue.dashboard_alerts.overdue_invoices')}}
            .tw-text-2xl.tw-font-bold.tw-text-red-600 {{alerts.overdue_invoices}}
            a.tw-text-xs.tw-text-blue-500(:href="'/iov'") {{$I18n.t('vue.dashboard_alerts.view_details')}}
          .tw-bg-red-100.tw-rounded-full.tw-p-3
            i.fa-solid.fa-exclamation-triangle.tw-text-red-600.fa-lg

    .col-md-4.col-sm-6.mb-3(v-if="alerts.upcoming_maintenances > 0")
      .app-card.p-3.h-100
        .d-flex.justify-content-between.align-items-center
          div
            .tw-text-xs.tw-text-gray-500.tw-uppercase.tw-font-semibold.mb-1
              i.fa-solid.fa-tools.me-1.tw-text-yellow-500
              | {{$I18n.t('vue.dashboard_alerts.upcoming_maintenances')}}
            .tw-text-2xl.tw-font-bold.tw-text-yellow-600 {{alerts.upcoming_maintenances}}
            a.tw-text-xs.tw-text-blue-500(:href="upcomingMaintenancesUrl") {{$I18n.t('vue.dashboard_alerts.view_details')}}
          .tw-bg-yellow-100.tw-rounded-full.tw-p-3
            i.fa-solid.fa-tools.tw-text-yellow-600.fa-lg

    .col-md-4.col-sm-6.mb-3(v-if="alerts.unbilled_orders > 0")
      .app-card.p-3.h-100
        .d-flex.justify-content-between.align-items-center
          div
            .tw-text-xs.tw-text-gray-500.tw-uppercase.tw-font-semibold.mb-1
              i.fa-solid.fa-file-invoice.me-1.tw-text-blue-500
              | {{$I18n.t('vue.dashboard_alerts.unbilled_orders')}}
            .tw-text-2xl.tw-font-bold.tw-text-blue-600 {{alerts.unbilled_orders}}
            a.tw-text-xs.tw-text-blue-500(:href="'/owwi'") {{$I18n.t('vue.dashboard_alerts.view_details')}}
          .tw-bg-blue-100.tw-rounded-full.tw-p-3
            i.fa-solid.fa-file-invoice.tw-text-blue-600.fa-lg

    .col-md-3.col-sm-6.mb-3(v-if="alerts.pending_notifications > 0")
      .app-card.p-3.h-100
        .d-flex.justify-content-between.align-items-center
          div
            .tw-text-xs.tw-text-gray-500.tw-uppercase.tw-font-semibold.mb-1
              i.fa-solid.fa-bell.me-1.tw-text-cyan-500
              | {{$I18n.t('vue.dashboard_alerts.pending_notifications')}}
            .tw-text-2xl.tw-font-bold.tw-text-cyan-600 {{alerts.pending_notifications}}
            a.tw-text-xs.tw-text-blue-500(href="#" @click.prevent="$emit('open-notifications')") {{$I18n.t('vue.dashboard_alerts.view_details')}}
          .tw-bg-cyan-100.tw-rounded-full.tw-p-3
            i.fa-solid.fa-bell.tw-text-cyan-600.fa-lg

  //- Quick Actions section hidden
  //- .row.mb-3(v-if="hasAnyAlerts")
  //-   .col-12
  //-     .app-card.p-3
  //-       h6.tw-text-gray-500.mb-3
  //-         i.fa-solid.fa-bolt.me-2
  //-         | {{$I18n.t('vue.dashboard_alerts.quick_actions')}}
  //-       .d-flex.gap-2.flex-wrap
  //-         button.app-btn-link-primary(v-if="alerts.unbilled_orders > 0" @click="generateInvoices")
  //-           i.fa-solid.fa-file-invoice.me-1
  //-           | {{$I18n.t('vue.dashboard_alerts.generate_invoices')}}
  //-         button.app-btn-link-primary(v-if="alerts.upcoming_maintenances > 0" @click="scheduleMaintenances")
  //-           i.fa-solid.fa-calendar.me-1
  //-           | {{$I18n.t('vue.dashboard_alerts.schedule_maintenances')}}
  //-         button.app-btn-link-primary(v-if="alerts.overdue_invoices > 0" @click="sendReminders")
  //-           i.fa-solid.fa-envelope.me-1
  //-           | {{$I18n.t('vue.dashboard_alerts.send_reminders')}}

  .row(v-if="!hasAnyAlerts")
    .col-12
      .app-card.p-3.text-center
        i.fa-solid.fa-check-circle.fa-3x.tw-text-green-500.mb-3
        h5.tw-text-gray-500 {{$I18n.t('vue.dashboard_alerts.all_clear')}}
        p.tw-text-gray-400.tw-text-sm {{$I18n.t('vue.dashboard_alerts.no_urgent_items')}}
</template>

<script>
const { BackendService } = require('app/services');

export default {
  props: {
    dataAlerts: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      alerts: this.dataAlerts
    };
  },
  computed: {
    hasAnyAlerts() {
      return this.alerts.overdue_invoices > 0 ||
             this.alerts.upcoming_maintenances > 0 ||
             this.alerts.unbilled_orders > 0 ||
             this.alerts.pending_notifications > 0;
    },
    upcomingMaintenancesUrl() {
      // Generate URL with date filters for next 7 days
      const today = new Date();
      const in7Days = new Date();
      in7Days.setDate(today.getDate() + 7);
      
      const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };
      
      const initialDate = formatDate(today);
      const finalDate = formatDate(in7Days);
      
      return `/m?query[initial_due_date]=${initialDate}&query[final_due_date]=${finalDate}`;
    }
  },
  methods: {
    generateInvoices() {
      if (confirm(this.$I18n.t('vue.dashboard_alerts.confirm_generate_invoices'))) {
        // Navigate to orders page with auto-generate parameter
        window.location.href = '/o?auto_generate_invoices=true';
      }
    },
    scheduleMaintenances() {
      window.location.href = '/m';
    },
    sendReminders() {
      if (confirm(this.$I18n.t('vue.dashboard_alerts.confirm_send_reminders'))) {
        BackendService.post('/invoices/send_payment_reminders')
          .then(() => {
            alert(this.$I18n.t('vue.dashboard_alerts.reminders_sent'));
          })
          .catch(error => {
            console.error('Error sending reminders:', error);
            alert(this.$I18n.t('vue.dashboard_alerts.error_sending'));
          });
      }
    }
  }
};
</script>

<style scoped>
/* Estilos manejados por Tailwind CSS */
</style>
